import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { Home, PiggyBank, HandCoins, ScrollText, Users, User, LogOut, AwardIcon } from "lucide-react";

const NAV = [
  { to:"/",            icon:Home,       label:"Dashboard", end:true },
  { to:"/savings",     icon:PiggyBank,  label:"Savings",   end:false },
  { to:"/loans",       icon:HandCoins,  label:"Loans",     end:false },
  { to:"/activity",    icon:ScrollText, label:"Activity",  end:false },
  /* { to:"/members",     icon:Users,      label:"Members",   end:false }, */
];

export default function MemberLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen bg-slate-50">
      {/* Sidebar */}
      <aside className="hidden md:flex w-56 flex-col bg-white border-r border-slate-200 flex-shrink-0">
        <div className="p-5 border-b border-slate-100 flex items-center gap-3">
          <div className="w-9 h-9 rounded-xl bg-emerald-600 flex items-center justify-center text-white text-lg">
            {/* 🌿 */}
            <img src="/heritage.jpg" width="40" height="40" alt="logo" ></img>
          </div>
          <span className="font-medium text-slate-800">Heritage</span>
        </div>
        <nav className="flex-1 p-3 space-y-0.5">
          {NAV.map(({ to, icon:Icon, label, end }) => (
            <NavLink key={to} to={to} end={end}
              className={({ isActive }) =>
                `flex items-center gap-2.5 px-3 py-2.5 rounded-lg text-sm transition-colors
                 ${isActive ? "bg-emerald-50 text-emerald-700 font-medium" : "text-slate-600 hover:bg-slate-50"}`}>
              <Icon size={17}/> {label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-slate-100">
          <NavLink to="/profile" className="flex items-center gap-2.5 px-3 py-2 rounded-lg text-sm text-slate-600 hover:bg-slate-50">
            <User size={17}/> {user?.first_name} {user?.last_name}
          </NavLink>
          {user?.role === "admin" && (
            <button onClick={() => navigate("/admin")}
              className="w-full flex items-center gap-2.5 px-3 py-2 rounded-lg text-sm text-violet-600 hover:bg-violet-50 mt-1">
              🛡️ Admin console
            </button>
          )}
          <button onClick={() => { logout(); navigate("/login"); }}
            className="w-full flex items-center gap-2.5 px-3 py-2 rounded-lg text-sm text-red-600 hover:bg-red-50 mt-1">
            <LogOut size={17}/> Sign out
          </button>
        </div>
      </aside>

      {/* Content */}
      <div className="flex-1 flex flex-col min-w-0">
        <header className="bg-white border-b border-slate-200 px-6 py-4 flex items-center justify-between">
          <h1 className="text-lg font-medium text-slate-800">Heritage</h1>
          {user?.kyc_status === 'verified'? "" : user?.kyc_status === 'rejected'? 
            <em style={{color:"red", border:"solid", borderColor:"red", borderWidth:"1px", borderRadius:"7px", padding:"3px", fontSize:"11px"}}>Your KYC document was rejected. Please go to profile page and re-upload KYC documents
              <span className="px-2 py-0.5 rounded-full" onClick={() =>navigate("/profile")} style={{cursor:"pointer"}}> ➡️</span>
            </em> :
            <h3 style={{color:"orange", border:"solid", borderColor:"orange", borderWidth:"1px", borderRadius:"7px", padding:"3px", fontSize:"11px"}}>Your KYC is pending review and approval</h3>}
          <div className="flex items-center gap-3 text-sm text-slate-500">
            <span className="hidden sm:inline">{user?.email}</span>
            <span onClick={() =>navigate("/profile")} style={{cursor:"pointer"}} className="px-2 py-0.5 rounded-full {user?.kyc_status == 'verified'? 'bg-emerald-50' : 'bg-amber-500'} text-emerald-700 text-xs border border-emerald-200">👤 {user?.kyc_status === 'verified'? "✅" : "⚠️"}</span>
          </div>
        </header>
        <main className="flex-1 p-6 overflow-y-auto"><Outlet/></main>
        {/* Mobile bottom nav */}
        <nav className="md:hidden flex border-t border-slate-200 bg-white">
          {NAV.map(({ to, icon:Icon, label, end }) => (
            <NavLink key={to} to={to} end={end}
              className={({ isActive }) =>
                `flex-1 flex flex-col items-center py-3 text-xs gap-1 ${isActive ? "text-emerald-600" : "text-slate-400"}`}>
              <Icon size={20}/>{label}
            </NavLink>
          ))}
        </nav>
      </div>
    </div>
  );
}
